module.exports = __webpack_public_path__ + "img/carrousel-mov-digi-1.858cf9d1.png";